import { render, staticRenderFns } from "./CNICPromosExpiringInAWeek.vue?vue&type=template&id=f5e4e8f2"
import script from "./CNICPromosExpiringInAWeek.vue?vue&type=script&lang=js"
export * from "./CNICPromosExpiringInAWeek.vue?vue&type=script&lang=js"
import style0 from "./CNICPromosExpiringInAWeek.vue?vue&type=style&index=0&id=f5e4e8f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports